import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { fieldLabelStyle } from '../lib/theme';
import AuthLayout, {
  authFieldStyle,
  authFormStyle,
  authSubmitStyle,
} from '../components/AuthLayout';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post('/auth/request-reset', { email });
    } finally {
      setSubmitting(false);
      setSubmitted(true);
    }
  }

  if (submitted) {
    return (
      <AuthLayout title="Check your email">
        <p style={{ opacity: 0.75, textAlign: 'center', marginTop: 0 }}>
          If an account exists for that email, a password reset link has been sent. It expires in 15 minutes.
        </p>
        <div style={{ textAlign: 'center' }}>
          <Link to="/login">Back to log in</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Forgot password">
      <form onSubmit={handleSubmit} style={authFormStyle}>
        <label style={fieldLabelStyle}>
          Email
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={authFieldStyle} />
        </label>

        <button type="submit" disabled={submitting} style={authSubmitStyle}>
          {submitting ? 'Sending…' : 'Send reset link'}
        </button>

        <Link to="/login" style={{ fontSize: '0.85rem', textAlign: 'center' }}>
          Back to log in
        </Link>
      </form>
    </AuthLayout>
  );
}
